'use client';
import { useContext } from 'react';
import { WizardContext } from './Wizard.component';
export function useWizardContext() {
    const result = useContext(WizardContext);
    if (!result) {
        throw new Error('useWizardContext can only be used inside a WizardContext.Provider');
    }
    const { state, setState, steps, stepId, setStepId, icons } = result;
    const currentStep = steps.find((step)=>step.id === stepId);
    if (!currentStep) {
        throw new Error(`step ${stepId} not found`);
    }
    const goToStep = (id)=>{
        setStepId(id);
    };
    const goToNextStep = ()=>{
        const index = steps.findIndex((step)=>step.id === stepId);
        if (index === -1 || index + 1 >= steps.length) {
            return;
        }
        setStepId(steps[index + 1].id);
    };
    const goToPreviousStep = ()=>{
        const index = steps.findIndex((step)=>step.id === stepId);
        if (index === -1 || index - 1 < 0) {
            return;
        }
        setStepId(steps[index - 1].id);
    };
    return {
        wizardState: state,
        setWizardState: setState,
        steps,
        currentStep,
        goToStep,
        goToNextStep,
        goToPreviousStep,
        icons
    };
}
